import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // Hook to navigate to different routes

  const handleLogin = async () => {
    try {
      const response = await axios.post('https://upload.hariombusinessenterprise.com/login.php', {
        username,
        password
      });

      if (response.data.status === 'success') {
        // If login is successful, navigate to /fetchdata
        navigate('/firebasefile');
      } else {
        // If login fails, show an error message
        console.error("Login failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error logging in:", error);
    }
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Username"
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
};

export default Login;
